import React, { useState } from 'react'
import PropTypes from 'prop-types'

import {
  SERVICE_LABEL_ADVISOR,
  SERVICE_LABEL_INVESTOR,
  UI_LABEL_ADVISOR,
  UI_LABEL_INVESTOR,
  SERVICE_LABEL_WHOLESALER,
} from '../Helper/constants.js'
import './profile.css'

function Profile(props) {
  const [enableEditProfile, setEditEnableProfile] = useState(false)

  const { userSubscriptionProfile, handleUpdateProfile, storageProfile } = props

  const [profileInfo, setProfileInfo] = useState({
    contactID: userSubscriptionProfile.contactID,
    firstName: userSubscriptionProfile.firstName,
    lastName: userSubscriptionProfile.lastName,
    emailId: userSubscriptionProfile.emailId,
    role: userSubscriptionProfile.role,
    subscriptionsEnabled: '',
  })

  const handleInputChange = (event) => {
    event.preventDefault()

    const _profileInfo = { ...profileInfo }

    _profileInfo[event.target.id] = event.target.value

    setProfileInfo(_profileInfo)
  }

  const handleEditProfileClick = () => {
    setEditEnableProfile(true)
  }

  const handleEditProfileCancelClick = (event) => {
    event.preventDefault()

    setEditEnableProfile(false)
  }

  const handleEditProfileSaveClick = (event) => {
    event.preventDefault()

    setEditEnableProfile(false)

    handleUpdateProfile(profileInfo)
  }

  return (
    <React.Fragment>
      {enableEditProfile && (
        <div className="u-marginBottom6gu">
          <h3 className="u-marginBottom3gu">Edit Profile</h3>
          <form>
            <label htmlFor="firstName" className="Form-label">
              First name
            </label>
            <input
              type="text"
              id="firstName"
              className="Input u-marginBottom3gu"
              name="First name"
              value={profileInfo.firstName}
              onChange={handleInputChange}
            />
            <label htmlFor="lastName" className="Form-label">
              Last name
            </label>
            <input
              type="text"
              id="lastName"
              className="Input u-marginBottom3gu"
              name="Last name"
              value={profileInfo.lastName}
              onChange={handleInputChange}
            />
            <label htmlFor="emailId" className="Form-label">
              Email address
            </label>
            <input
              type="text"
              id="emailId"
              className="Input u-marginBottom3gu"
              name="Email address"
              value={profileInfo.emailId}
              onChange={handleInputChange}
            />
            <button
              onClick={handleEditProfileSaveClick}
              className="Button Button--primary u-marginRight1gu"
              data-tracking="primary"
            >
              Save
            </button>
            <button
              onClick={handleEditProfileCancelClick}
              className="Button Button--tertiary u-textNoTransform"
              data-tracking="secondary"
            >
              Cancel
            </button>
          </form>
        </div>
      )}
      {!enableEditProfile && (
        <>
          <div className="u-marginBottom3gu u-sm-marginTop3gu">
            {userSubscriptionProfile.role !== SERVICE_LABEL_WHOLESALER &&
              userSubscriptionProfile.firstName && (
                <h3>Hi, {userSubscriptionProfile.firstName}</h3>
              )}
            {userSubscriptionProfile.role === SERVICE_LABEL_ADVISOR &&
              userSubscriptionProfile.contactStatusCd === 'Pending' && (
                <>
                  <h5 className="u-textLoose u-textNoTransform u-textSizeMsr">
                    Your account is{' '}
                    <div
                      className="Tooltip-target u-posRelative u-textColorDefault u-borderColorBlack"
                      aria-describedby="Pending-verification-tooltip"
                      role="button"
                      tabIndex="0"
                    >
                      pending verification
                      <div
                        className="Tooltip"
                        role="tooltip"
                        id="Pending-verification-tooltip"
                      >
                        <div className="Tooltip-content Content">
                          <p className="u-textSizeMsrm1">
                            You can set up your email subscription preferences
                            now, but you will not begin to receive your
                            subscriptions until we have verified your
                            information.
                          </p>
                        </div>
                      </div>
                    </div>
                  </h5>
                  <p className="u-marginBottom3gu u-textSecondary">
                    <em>Check back soon.</em>
                  </p>
                </>
              )}
          </div>
          {userSubscriptionProfile.role !== SERVICE_LABEL_INVESTOR && (
            <div
              className="u-marginBottom6gu"
              data-qa-automation="user-profile-section"
            >
              <p>
                {userSubscriptionProfile.firstName}{' '}
                {userSubscriptionProfile.lastName}
              </p>
              <h4 className="u-marginBottom1gu u-textOpen u-overflowHidden Profile-email">
                {userSubscriptionProfile.emailId}
              </h4>
              <p className="u-marginBottom1gu">
                {UI_LABEL_ADVISOR}
                {storageProfile.firmName && (
                  <>
                    ,<br />
                    {storageProfile.firmName}
                  </>
                )}
              </p>
            </div>
          )}
          {userSubscriptionProfile.role === SERVICE_LABEL_INVESTOR && (
            <div className="u-marginBottom6gu">
              <p>
                {userSubscriptionProfile.firstName}{' '}
                {userSubscriptionProfile.lastName}
              </p>
              <h4 className="u-marginBottom1gu u-textOpen u-overflowHidden Profile-email">
                {userSubscriptionProfile.emailId}
              </h4>
              <p className="u-marginBottom1gu">{UI_LABEL_INVESTOR}</p>
              {userSubscriptionProfile.source === 'ESC' && (
                <button
                  onClick={handleEditProfileClick}
                  className="Link u-textSecondary"
                  data-tracking="secondary"
                >
                  Edit Profile
                </button>
              )}
            </div>
          )}
        </>
      )}
      {userSubscriptionProfile.role === SERVICE_LABEL_ADVISOR &&
        userSubscriptionProfile.source === 'ESC' && (
          <div data-qa-automation="new-user-profile-section">
            <h3 className="u-textLoose">Unlock All Content</h3>
            <p className="u-marginBottom3gu">
              To access all subscriptions and site resources, please complete
              your registration.
            </p>
            <a
              href="/register"
              className="Button Button--secondary u-block u-paddingVert2gu"
              data-analytics="cesc-complete-registration"
            >
              <span className="locked-content-icon-link u-marginRight1gu"></span>
              Complete site registration
            </a>
          </div>
        )}
    </React.Fragment>
  )
}

Profile.propTypes = {
  userSubscriptionProfile: PropTypes.object.isRequired,
  handleUpdateProfile: PropTypes.func.isRequired,
  storageProfile: PropTypes.object,
}

export default Profile
